import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { setError, setAlert } from 'store/actions/global'
import { clearAuthAlert } from 'store/actions/auth'
import { clearDidsError } from 'store/actions/profile'
import { clearAlertPhoneError } from 'store/actions/call'
import { useTranslation } from 'react-i18next'

import './AlertContainer.scss'
import { Alert } from './Alert'

export function AlertContainer() {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const { connectionError, reconnectionFailed } = useSelector((state) => state.userAgent)
    const { message, error } = useSelector((state) => state.auth)
    const { validationPhoneError } = useSelector((state) => state.call)
    const { didsErrorMessage } = useSelector((state) => state.profile)
    const { error: globalError, alert } = useSelector((state) => state.global)

    const [connectionErrorMessage, setConnectionErrorMessage] = useState('')
    const [reconnectionFailedMessage, setReconnectionFailedMessage] = useState('')

    const [alerts, setAlerts] = useState([])
    const [isThereAnyAlert, setIsThereAnyAlert] = useState(false)

    const messages = [
        message,
        error,
        validationPhoneError,
        didsErrorMessage,
        connectionErrorMessage,
        reconnectionFailedMessage,
        globalError,
        alert
    ]

    const permanent = [connectionErrorMessage, reconnectionFailedMessage]
    const topPositioned = [connectionErrorMessage, reconnectionFailedMessage, globalError]

    const closeAlert = (itemIndex) => {
        switch (alerts[itemIndex]) {
            case reconnectionFailedMessage:
                setReconnectionFailedMessage()
                break
            case connectionErrorMessage:
                setConnectionErrorMessage()
                break
            case message:
                dispatch(clearAuthAlert())
                break
            case error:
                dispatch(clearAuthAlert())
                break
            case validationPhoneError:
                dispatch(clearAlertPhoneError())
                break
            case globalError:
                dispatch(setError())
                break
            case alert:
                dispatch(setAlert())
                break
            case didsErrorMessage:
                dispatch(clearDidsError())
                break
            default:
                break
        }
    }

    const isItemTimeOut = (alertItem) => {
        return !permanent.some((item) => item === alertItem)
    }

    const isPositionedTop = (alertItem) => {
        return topPositioned.some((item) => item === alertItem)
    }

    useEffect(() => {
        setAlerts(messages)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, messages)

    useEffect(() => {
        setIsThereAnyAlert(alerts.some((item) => item?.length))
    }, [alerts])

    useEffect(() => {
        setConnectionErrorMessage(connectionError ? t('ws_disconnection') : '')
    }, [connectionError, t])

    useEffect(() => {
        setReconnectionFailedMessage(reconnectionFailed ? t('ws_reconnection_failed') : '')
    }, [reconnectionFailed, t])

    return (
        isThereAnyAlert && (
            <>
                <div className="alert-shadow" />
                <div className="alert-wrapper">
                    <div className="alert-wrapper--top">
                        {alerts.map(
                            (message, i) =>
                                message &&
                                isPositionedTop(message) && (
                                    <Alert
                                        key={i}
                                        message={message}
                                        isTimeOut={isItemTimeOut(message)}
                                        closeAction={() => closeAlert(i)}
                                    />
                                )
                        )}
                    </div>

                    <div className="alert-wrapper--bottom">
                        {alerts.map(
                            (message, i) =>
                                message &&
                                !isPositionedTop(message) && (
                                    <Alert
                                        key={i}
                                        message={message}
                                        isTimeOut={isItemTimeOut(message)}
                                        closeAction={() => closeAlert(i)}
                                    />
                                )
                        )}
                    </div>
                </div>
            </>
        )
    )
}
